import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=f5a75c6a&scoped=true"
import script from "./Step6.vue?vue&type=script&lang=js"
export * from "./Step6.vue?vue&type=script&lang=js"
import style0 from "./Step6.vue?vue&type=style&index=0&id=f5a75c6a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a75c6a",
  null
  
)

export default component.exports